import { render, staticRenderFns } from "./HeaderOrganisation.vue?vue&type=template&id=b0824e40&"
import script from "./HeaderOrganisation.vue?vue&type=script&lang=js&"
export * from "./HeaderOrganisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports